import React from 'react';
import { features } from '../data/mock';
import { Zap, BadgeCheck, Shield, Users } from 'lucide-react';

const iconList = [Zap, BadgeCheck, Shield, Users];

const FeaturesSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-[#302f2c]">
      <div className="container mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#888680] text-sm font-medium uppercase tracking-wide mb-4 block">
              Neden Biz?
            </span>
            <h2 className="text-[#f97316] font-black text-4xl md:text-6xl uppercase leading-[0.85] mb-6">
              Güvenilir<br />Tamir<br />Hizmeti
            </h2>
            <p className="text-[#888680] text-lg leading-relaxed mb-8">
              10 yılı aşkın tecrübemiz ve müşteri memnuniyeti odaklı yaklaşımımızla 
              Eskişehir'de küçük ev aletleri tamirinde lider konumdayız.
            </p>
            <div className="flex items-center gap-4">
              <div className="text-center">
                <span className="text-[#f97316] font-black text-4xl md:text-5xl block">10+</span>
                <span className="text-[#888680] text-sm uppercase tracking-wide">Yıl Deneyim</span>
              </div>
              <div className="w-px h-16 bg-[#4a2a10]" />
              <div className="text-center">
                <span className="text-[#f97316] font-black text-4xl md:text-5xl block">5000+</span>
                <span className="text-[#888680] text-sm uppercase tracking-wide">Mutlu Müşteri</span>
              </div>
              <div className="w-px h-16 bg-[#4a2a10]" />
              <div className="text-center">
                <span className="text-[#f97316] font-black text-4xl md:text-5xl block">%98</span>
                <span className="text-[#888680] text-sm uppercase tracking-wide">Memnuniyet</span>
              </div>
            </div>
          </div>

          {/* Right - Features Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {features.map((feature, index) => {
              const IconComponent = iconList[index];
              return (
                <div
                  key={feature.id}
                  className="bg-[#1a1c1b] border border-[#4a2a10]/50 p-6 transition-all duration-300 hover:border-[#f97316]/50"
                >
                  <div className="w-12 h-12 bg-[#4a2a10] rounded-full flex items-center justify-center mb-4">
                    <IconComponent size={20} className="text-[#f97316]" />
                  </div>
                  <h3 className="text-[#f97316] font-bold text-lg mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-[#888680] text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
